(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["centered-choice-panel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (event) {
  var tab = event.target.closest('[data-ccp-tab]');
  if (!tab) return;
  var root = tab.closest('.ccp');
  if (!root) return;

  root.querySelectorAll('[data-ccp-tab]').forEach(function (btn) {
    var active = btn === tab;
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-selected', active ? 'true' : 'false');
  });

  var key = tab.getAttribute('data-ccp-tab');
  root.querySelectorAll('[data-ccp-panel]').forEach(function (panel) {
    panel.classList.toggle('is-active', panel.getAttribute('data-ccp-panel') === key);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
